import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../api/api";
import Layout from "../components/Layout";

export default function AddRound() {
  const { interviewId } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "",
    description: "",
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError("");

    try {
      const payload = {
        name: form.name,
        description: form.description,
      };

      const res = await api.post(`/interviews/${interviewId}/rounds`, payload);

      const roundId = res.data.round.id;

      // ✅ Redirect to manage questions for the newly created round
      navigate(`/interviews/${interviewId}/rounds/${roundId}/questions`);
    } catch (err) {
      console.error("Failed to create round:", err.response?.data || err.message);
      setError("❌ Could not create round. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Layout>
      <h2 className="text-2xl font-bold mb-4">Add New Round</h2>

      {error && (
        <div className="text-red-600 mb-4">{error}</div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          name="name"
          className="border px-3 py-2 w-full rounded"
          placeholder="Round Name (e.g., Technical Round)"
          value={form.name}
          onChange={handleChange}
          required
        />

        <textarea
          name="description"
          className="border px-3 py-2 w-full rounded"
          placeholder="Optional description about this round"
          value={form.description}
          onChange={handleChange}
          rows="3"
        />

        <button
          type="submit"
          disabled={saving}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          {saving ? "Saving..." : "Create & Manage Questions →"}
        </button>
      </form>
    </Layout>
  );
}
